var width = window.innerWidth;

window.onload = (function(){

  var chaty_icon_svg_btn = document.getElementById("chaty_icon_svg_btn");
  var add_chaty_class = document.getElementById("chaty_icon_svg");
  var chaty_main_btn = document.getElementById("chaty_main_btn");
 
  if(width > 980){
 
    document.getElementById("chaty_icon_svg_btn").addEventListener("mouseenter", mouseOver);
    
    function mouseOver() {
          var available = document.getElementsByClassName("add_chaty_class");
          add_chaty_class.classList.add("add_chaty_class");
          if (document.querySelector(".chaty_main_btn").classList.contains("btn_show_class")) {
            chaty_main_btn.classList.remove("btn_show_class");
            chaty_main_btn.classList.remove("add_chaty_class");
            chaty_main_btn.classList.add("btn_hide_class");

          }
          chaty_icon_svg_btn.style.transform = "rotate(180deg)";
    }
  }
  document.getElementById("chaty_icon_svg_btn").addEventListener("click", clickevent);
  var chaty_icon_svg_btn = document.getElementById("chaty_icon_svg_btn");
  var add_chaty_class = document.getElementById("chaty_icon_svg");
  var chaty_main_btn = document.getElementById("chaty_main_btn");
  
  function clickevent(){
    var available = document.getElementsByClassName("add_chaty_class");
    var temp = document.querySelector("#chaty_icon_svg").classList.contains("add_chaty_class");
      if (document.querySelector("#chaty_icon_svg").classList.contains("add_chaty_class")) {
       add_chaty_class.classList.remove("add_chaty_class");
       chaty_main_btn.classList.remove("btn_hide_class");
       chaty_main_btn.classList.add("btn_show_class");
       chaty_icon_svg_btn.style.transform = "rotate(0deg)";
       chaty_icon_svg_btn.style.transition = "all 0.5s";
    }
    else{ 
      add_chaty_class.classList.add("add_chaty_class");
      chaty_main_btn.classList.remove("btn_show_class");
      chaty_main_btn.classList.add("btn_hide_class");
      chaty_icon_svg_btn.classList.add("chaty_icon_svg_btn");
      chaty_icon_svg_btn.style.transform = "rotate(180deg)";
    }
  }
  
  for (var i = 0; i < icons.length; i++) {
    if (icons[i] == 'Whatsapp') {
      var id = document.getElementById('Whatsapp');
      var value = id.getAttribute('data-value');
      document.getElementById("Whatsapp").href = "https://web.whatsapp.com/send?phone="+value+""; 
      if(width < 530) {
      document.getElementById("Whatsapp").href = "https://wa.me/"+value+"";

      }
    }
  }     
  
})();

window.onload = (function(){
    $('.wechat_image').on('click', function () {
        $('.wechatimage').toggleClass('open');
    });
})();